import { render, staticRenderFns } from "./g6_graph.vue?vue&type=template&id=462fa8a9&scoped=true&"
import script from "./g6_graph.vue?vue&type=script&lang=js&"
export * from "./g6_graph.vue?vue&type=script&lang=js&"
import style0 from "./g6_graph.vue?vue&type=style&index=0&id=462fa8a9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462fa8a9",
  null
  
)

export default component.exports